import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory, Link } from "react-router-dom";
import { useState , useEffect} from "react";

const Header = ({ children, hasHiddenAuthButtons}) => {
 // const[isLogIn, setIsLogIn] = useState(false);

  /*useEffect(()=>{
    let key = localStorage.getItem('username');
    if(key!==null){
      setIsLogIn(true);
    }
  },[]);
  */

  const token = localStorage.getItem('token');
  
  const history = useHistory();
  const clearData=()=>{
    localStorage.clear();
    window.location.reload();
    //history.push('/');
  }
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {
        !hasHiddenAuthButtons &&<Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text" onClick={()=>{ history.push('/')}}
        >
         Back to explore
        </Button>
        }
        {
          hasHiddenAuthButtons && (!token) &&
          <>
          
            {children}
            
          <Box>
          <Button variant="text" onClick={()=>{ history.push('/login')}}>
            LOGIN
            </Button>

          <Button variant="contained" onClick={()=>{ history.push('/register')}} style={{ textDecoration: 'none', color: 'white' }}>
            REGISTER
          </Button>
          
          </Box>
          </>
        }
         {
          hasHiddenAuthButtons && (token)&& 
          <>
           
              {children}
          
             
          <Stack direction="row" spacing={2}>
          
          <Avatar alt={localStorage.getItem('username')} src="avatar.png" />
          <p className="user-name">{localStorage.getItem('username')}</p>
          <Button variant="text" onClick = {clearData}>
            
            LOGOUT</Button>
          </Stack>
          </>
        }
      </Box>
    );
};

export default Header;
